export default "__VITE_ASSET__ee1c216f__"